<template>
  <div class="notes">
    <panel>
      <h1>{{header}}</h1>
      <list :items="formattedNotes" :loading="fetching" @edit="onEdit" @delete="onDelete" @reached-bottom="onReachedBottom" ref="list" class="list">
        <template v-slot:itemDisplay="{ item }">
          <span class="weekday">
            [{{getWeekdayLabel(item.weekday)}}]
          </span> 
          <span>{{item.value}}</span>
        </template>
        <template v-slot:itemEdit="{ item }">
          <div class="edit">
            <textarea
              v-model="item.value" 
              ref="textarea"
              :disabled="item.loading"/>
            <div class="input">
              <select name="weekday" id="weekday" v-model="item.weekday">
                <option v-for="day in weekdays" :key="day.value" :value="day.value">{{day.label}}</option>
              </select>
              <div class="create">
                <button @click="cancelEdit">Cancel</button>
                <button @click="update(item.id, item.value, item.weekday)">Update</button>
              </div>
            </div>
          </div>
        </template>
      </list>
      <br>
      <input type="text" v-model="text" autofocus @input="onInput">
      <div class="input">
        <select name="weekday" id="weekday" v-model="weekday">
          <option v-for="day in weekdays" :key="day.value" :value="day.value">{{day.label}}</option>
        </select>
        <div class="create"><button @click="create">Create</button></div>
      </div>
    </panel>
  </div>
</template>

<script>

import { weekdays } from '../assets/js/helpers'

export default {
    name: 'Weekly',
    data() {
      return {
        header: 'Weekly',
        labelId: 4,
        localStorageKey: 'new_weekly_text',
        notes: [],
        text: localStorage.getItem('new_weekly_text') || '',
        weekday: parseInt(localStorage.getItem('new_weekly_weekday')) || 1,
        weekdays,
        loadingIds: [],
        skip: 0,
        limit: 15,
        increase: 15,
        fetching: false,
        fetchedEverything: false
      }
    },
    methods: {
      getWeekdayLabel(weekday) {
        return this.weekdays.find(day => day.value === weekday).label;
      },
      onReachedBottom() {
        if (this.fetchedEverything) return;
        if (this.fetching) return;

        this.skip += this.increase; 
        this.get();
      },
      get() {
        this.fetching = true;

        this.axios.get(this.config.api + `/notes?limit=${this.limit}&offset=${this.skip}&labelId=${this.labelId}`)
          .then(result => {
            this.fetching = false;

            this.fetchedEverything = result.data.length < this.increase;

            this.notes = [...this.notes, ...result.data];
          })
          .catch(error => {
            const isAuthenticationError = error.message.includes('401');

            if (isAuthenticationError)
              return this.$router.push('/authorization')
            else alert(error.message)
          })
      },
      create() {
        if (this.text === '') return;

        this.axios.post(this.config.api + '/notes', { text: this.text, labelId: this.labelId, weekday: this.weekday })
          .then(result => {
            localStorage.removeItem(this.localStorageKey);
            localStorage.removeItem('new_weekly_weekday');
            this.text = '';
            
            this.notes.push({
              id: result.data.id,
              weekday: this.weekday,
              text: result.data.text
            })
          })
          .catch(error => {
            alert(error.message);
          })
      },
      update(id, text, weekday) {
        this.loadingIds.push(id);
        const noteIndex = this.notes.map(note => note.id).indexOf(id);
        this.notes[noteIndex].text = text;
        this.notes[noteIndex].weekday = weekday;

        this.axios.put(this.config.api + '/notes/' + id, { text, weekday })
          .then(() => {
            const loadingIdIndex = this.loadingIds.indexOf(id);

            this.loadingIds.splice(loadingIdIndex, 1);

            console.log(this.$refs);
          })
          .catch(error => {
            alert(error.message);
          })
      },
      cancelEdit() {
        this.$refs.list.stopEdit();
      },
      onInput() {
        localStorage.setItem(this.localStorageKey, this.text);
      },
      onEdit(item) {
        if (item.value === '') return;
        
        this.update(item.id, item.value);
      },
      onDelete(item) {
        
        if (confirm('are you sure?')) {
          this.loadingIds.push(item.id);
          this.axios.delete(this.config.api + '/notes/' + item.id)
            .then(() => {
              const index = this.notes.findIndex(item_ => item_.id === item.id);

              this.notes.splice(index, 1);
            })
            .catch(error => {
              alert(error.message);
            })
        }
      }
    },
    computed: {
      formattedNotes: function() {
        return this.notes.map(note => {
          return {
            id: note.id,
            value: note.text,
            weekday: note.weekday,
            loading: this.loadingIds.includes(note.id)
          }
        });
      }
    },
    created() {
      this.get();
    }
}
</script>

<style scoped>

.notes {
  height: 100%;
}

.list {
  height: calc(100vh - 250px);
}

.input {
  display: flex;
  justify-content: space-between;
}

.edit {
  width: 100%;
}

select {
  margin: 5px;
}

span.weekday {
  color: #29415c
}

textarea {
  height: initial;
}

</style>


// WEBPACK FOOTER //
// src/components/Weekly.vue